import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSetAtom, useAtomValue } from 'jotai';
import {
  Box,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
} from '@mui/material';
import useAPI from '../../../../api';
import LoadButton from '../../../Editor/Components/Media/LoadButton';
import { openSnackbarAdviseAtom, selectedBranchAtom } from '../../../../Atoms';
import getErrorMessage from '../../../../Helpers/Errors/getErrorMessage';

const LoadingFilesWidget = function LoadingFilesWidget({
  sections = [],
  campaigns = [],
  closeDialog = () => {},
  reloadHistory = () => {},
}) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const API = useAPI();

  const [section, setSection] = useState('');
  const [subSection, setSubSection] = useState('');
  const [campaign, setCampaign] = useState('');

  const selectedBranch = useAtomValue(selectedBranchAtom);
  const openSnackbar = useSetAtom(openSnackbarAdviseAtom);

  const handleChangeSection = (event) => {
    setSection(event.target.value);
  };

  const handleChangeSubSection = (event) => {
    setSubSection(event.target.value);
  };

  const handleChangeCampaign = (event) => {
    setCampaign(event.target.value);
  };

  const isCommercial = sections?.find(({ id }) => id === section)?.isCommercial;

  const handleLoadWave = (event) => {
    const formData = new FormData();
    [...event.target.files].forEach((file) => formData.append('files', file));
    formData.append('branchId', selectedBranch.id);
    formData.append('sectionId', subSection);
    if (isCommercial) {
      formData.append('campaignId', campaign);
    }

    API.importWave(
      formData,
      { doNotStringify: true },
      () => {
        closeDialog();
        reloadHistory();
      },
      (err) => {
        openSnackbar({
          severity: 'error',
          message: getErrorMessage(err),
        });
      }
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        width: '100%',
        height: '100%',
      }}
    >
      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
        }}
      >
        {t('WAVE_UPLOAD_MESSAGE')}
      </Typography>
      <Typography variant="h6">
        {`${selectedBranch.branchDescription}*.xlsx`}
      </Typography>
      <FormControl fullWidth>
        <InputLabel id="section-select-inputlabel">{t('SECTIONS')}</InputLabel>
        <Select
          id="section-select"
          label={t('SECTIONS')}
          value={section}
          onChange={handleChangeSection}
        >
          {sections.map(({ id, name }) => (
            <MenuItem key={id} value={id}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {section && (
        <FormControl fullWidth>
          <InputLabel id="section-select-inputlabel">
            {t('SUBSECTIONS')}
          </InputLabel>
          <Select
            id="subsection-select"
            label={t('SUBSECTIONS')}
            value={subSection}
            onChange={handleChangeSubSection}
          >
            {sections
              .find(({ id }) => id === section)
              ?.subSections.map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}
      {isCommercial && (
        <FormControl fullWidth>
          <InputLabel id="section-select-inputlabel">
            {t('CAMPAIGN')}
          </InputLabel>
          <Select
            id="subsection-select"
            label={t('CAMPAIGN')}
            value={campaign}
            onChange={handleChangeCampaign}
          >
            {campaigns?.map(({ id, description }) => (
              <MenuItem key={id} value={id}>
                {description}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <LoadButton
        accept=".xlsx"
        onLoad={handleLoadWave}
        disabled={!subSection}
      />
    </Box>
  );
};

LoadingFilesWidget.propTypes = {
  sections: PropTypes.array,
  closeDialog: PropTypes.func,
  reloadHistory: PropTypes.func,
};

export default LoadingFilesWidget;
